import React from "react";

const OptionButton = ({serviceName, price, priceNote, isSelected, onSelect}) => {
  return(
    <div className={`options-button-container ${isSelected ? 'selected' : ''}`} onClick={onSelect}>
      <div className='service-name'>{serviceName}</div>
      <div className='service-price-container'>
        <div className='service-price'>{price}</div>
        {priceNote && <div className='price-note'>{priceNote}</div>}
      </div>
    </div>
  );
};

export default OptionButton;
